import React from "react";
import {Coordinates} from "./interfaces";

export const getRefRect = (ref: React.RefObject<any>) => ref.current.getBoundingClientRect();

export const getMouseCoordsInsideRef = (ref: React.RefObject<HTMLDivElement>, e: React.MouseEvent): Coordinates => {
    let rect = getRefRect(ref);
    let x = e.clientX - rect.x;
    let y = e.clientY - rect.y;
    return {x: x, y: y}
}
export const getCoordsInsideRef = (ref: React.RefObject<HTMLDivElement>, coords: Coordinates, fromCenter: boolean = false): Coordinates => {
    let rect = getRefRect(ref);
    let x = coords.x - rect.x;
    let y = coords.y - rect.y;
    if(fromCenter) {
        x = coords.x - (rect.x + (rect.width / 2));
        y = coords.y - (rect.y + (rect.height / 2));
    }
    return {x: x, y: y}
}